import { CategoryData } from './types';

export const filterHiddenCategories = (cats: CategoryData[]): CategoryData[] => {
    return cats.reduce((list, cat) => {
        if (cat.isHidden) {
            return list;
        }

        if (!cat.children) {
            return [...list, cat];
        }

        const children = filterHiddenCategories(cat.children);
        return [...list, { ...cat, children }];
    }, []);
};
